import * as XLSX from 'xlsx';
import i18n from '../../../../i18n';

export const ExportExcelWithHeader = (data: any[], headerInfo: Record<string, string>, fileName?: string) => {
    const wsData: any[][] = [];
    
    wsData.push(['']);
    wsData.push([i18n.t("documents.actRejection.actRejectionItemsPositionTabTitle")]);
    wsData.push(['']);
    
    Object.entries(headerInfo).forEach(([key, value]) => {
        wsData.push([`${key}:`, value]);
    });
    
    wsData.push(['']);
    wsData.push(['']);
    
    if (data.length > 0) {
        const headers = Object.keys(data[0]);
        wsData.push(headers);
        
        data.forEach((row) => {
            const rowData = headers.map((header) => row[header] || '');
            wsData.push(rowData);
        });
    }
    
    const worksheet = XLSX.utils.aoa_to_sheet(wsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, i18n.t("documents.actRejection.gridPluginName"));
    
    try {
        const colWidths: any[] = [];
        if (wsData.length > 0) {
            const maxCols = Math.max(...wsData.map(row => row.length));
            for (let i = 0; i < maxCols; i++) {
                let maxLength = 10;
                wsData.forEach((row) => {
                    if (row[i] !== undefined && row[i] !== null) {
                        const value = String(row[i]);
                        if (value.length > maxLength) {
                            maxLength = value.length;
                        }
                    }
                });
                colWidths.push({ wch: Math.min(maxLength + 2, 50) });
            }
        }
        worksheet['!cols'] = colWidths;
    } catch (error) {
        console.warn('Could not set column widths:', error);
    }
    
    const fileNameWithExt = `${fileName || 'export'}.xlsx`;
    XLSX.writeFile(workbook, fileNameWithExt);
};

// Экспорт XML 
export const ExportXML = (xml: string, fileName?: string) => {
    const blob = new Blob([xml], { type: 'application/xml' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName || 'export'}.xml`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};